module.exports = __webpack_public_path__ + "img/a-7z.44cbbe17.svg";